import React                      from 'react';

import { Container,
         PDFArea,
         XLSXArea,
         Label,
         AttachmentDOCVariants,
         attachmentdoc_variants } from 'src/components/features/inspection/view/attachment-doc/ui';

import * as types                 from 'src/services/api/types';
import Util                       from 'src/services/util';

import { useAppDispatch,
         storeApi               } from 'src/store';



type Props = {
  variant: AttachmentDOCVariants;
  doc: types.inspection.PieceFile | types.inspection.DefectFile;
  source: 'piece' | 'inspection';
}
export const AttachmentDOC: React.FC<Props> = ({ variant, doc, source }) => {
  const lookAndFeel = attachmentdoc_variants.get(variant)!;
  const dispatch = useAppDispatch();

  const isPDF = Util.getFileExt(doc.name).toUpperCase() === 'PDF';
  const isXLSX = Util.getFileExt(doc.name).toUpperCase() === 'XLSX';

  const onDownloadDOC = () => {
    if (doc.__dataUrl !== undefined)
    {
      const a = document.createElement("a");
      a.href = doc.__dataUrl;
      a.download = doc.name;
      a.click();
    }
    else
    {
      dispatch(storeApi.inspection.view.async.viewViewDOCAsync({
        fileName: doc.name,
        guid: doc.guid,
        source
      }))
        .unwrap()
        .then((result) => {
          
        })
        .catch((error) => { });
    }
  }

  return (
    <Container lookAndFeel = { lookAndFeel }>
      {isPDF && (
        <PDFArea lookAndFeel = { lookAndFeel } onClick = { onDownloadDOC } />
      )}
      {isXLSX && (
        <XLSXArea lookAndFeel = { lookAndFeel } onClick = { onDownloadDOC } />
      )}
      <Label lookAndFeel = { lookAndFeel }>
        { doc.name }
      </Label>
    </Container>
  );
}
